import React from "react";
import { Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/Login";
import { HomePage } from "./pages/homepage/Home";
// import { ProfilePage } from "./pages/Profile";
import { SettingsPage } from "./pages/Settings";
// import { ProtectedLayout } from "./components/ProtectedLayout";
import { MiniDrawer } from "./components/DrawerLayout";
import { UndefinePage } from "./pages/Undefine";
import { MenuPage } from "./pages/admin/MenuPage";
import { SignupPage } from "./pages/signup";
import { StoreSelect } from "./pages/StoreSelect";
import { Adash } from "./pages/admin/Adash";
import { InventoryPage } from "./pages/admin/Inventory/Inventory";

import { Order } from "./pages/admin/order";
import { LogoutPage } from "./pages/logoutPage";
import LayoutBuilder from "./LayoutBuilder/layoutBuilder";
import { Online } from "./pages/Online";
import UserInfoScreen from "./pages/admin/UserInfoScreen";
import { AdvanceSettingDevices } from "./pages/settings/AdvanceSettingDevices";
import ReportPage from "./pages/admin/Report";
import InstallationDocumentation from "./pages/homepage/installDoc";
import { TermsPage } from "./pages/termsPage";
import { ReportWrapper } from "./pages/admin/report/ReportWrapper";
import { InventoryReportPage } from "./pages/admin/report/InventoryReportPage";
import { InventoryLogReportPage } from "./pages/admin/report/InventoryLogReportPage";
import { PrintLayoutSettings } from "./pages/settings/printerLayouts";


export default function App() {
  return (
    <Routes>
      <Route>
        <Route path="/" element={<HomePage />} />
        <Route path="/support" element={<InstallationDocumentation />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<SignupPage />} />
      </Route>
      <Route path="/store" element={<StoreSelect />} />
      <Route path="/logout" element={<LogoutPage />} />

      {/*  */}
      <Route path="/tip" element={<ReportWrapper />} />
      <Route path="/clock-in" element={<ReportWrapper />} />
      <Route path="/epr" element={<ReportWrapper />} />
      <Route path="/sales-report" element={<ReportWrapper />} />
      <Route path="/orders-report" element={<ReportWrapper />} />
      <Route path="/item-report" element={<ReportWrapper />} />
      <Route path="/inventory-report" element={<InventoryReportPage />} />
      <Route path="/inventory-report-logs" element={<InventoryLogReportPage />} />
      <Route path="/admin" element={<MiniDrawer />}>
        <Route path="" element={<Adash />} />
        <Route path="order" element={<Order />} />
        <Route path="reservation" element={<UndefinePage />} />
        <Route path="menu" element={<MenuPage />} />
        <Route path="layout" element={<LayoutBuilder />} />
        <Route path="online" element={<Online />} />
        <Route path="reports" element={<ReportPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="user" element={<UserInfoScreen />} />
        <Route path="deviceAdvSet" element={<AdvanceSettingDevices />} />
        <Route path="printerLayouts" element={<PrintLayoutSettings />} />
        {/* <Route path="profile" element={<ProfilePage />} /> */}
        {/* following is temporary.. */}
        {/* <Route path="create" element={<CreateOrder />} /> */}
      </Route>

      <Route path="/terms" element={<TermsPage />} />      
      <Route path="*" element={<UndefinePage />} />
    </Routes>
  )
}